var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgyHp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2751_26853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.69043 1L11.9996 24.08L24.6896 1H-0.69043ZM2.68957 3H6.91957C5.84181 3.9913 5.08008 5.27824 4.72957 6.7L2.68957 3ZM11.9996 19.92L9.62957 15.61C11.1668 16.1297 12.8323 16.1297 14.3696 15.61L11.9996 19.92ZM11.9996 14C10.6287 13.9982 9.30789 13.4845 8.29603 12.5596C7.28417 11.6347 6.6542 10.3652 6.52957 9H11.9996V3C13.4583 3 14.8572 3.57946 15.8887 4.61091C16.9201 5.64236 17.4996 7.04131 17.4996 8.5C17.4996 9.95869 16.9201 11.3576 15.8887 12.3891C14.8572 13.4205 13.4583 14 11.9996 14ZM17.0796 3H21.3096L19.3096 6.7C18.948 5.27349 18.172 3.98601 17.0796 3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_26853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgyHp);
export default __webpack_public_path__ + "static/media/SGY-HP.2ce94575a3af38aeaece48c3949acb59.svg";
export { ForwardRef as ReactComponent };